// extracted by mini-css-extract-plugin
export var container = "List-module--container--D4vxu";
export var container__big = "List-module--container__big--Wl-TB";
export var container__small = "List-module--container__small--JkpHs";
export var container__small__item = "List-module--container__small__item--JOm04";